import { useEffect } from "react";
import { ApplicationFlowSteps } from "../../../route/application/authenticated/application-flow/types";

const LEFT = 0;
const TOP = 0;

export function useScrollToTop(page: ApplicationFlowSteps): void {
  useEffect(() => {
    window.scrollTo(LEFT, TOP);
  }, [page]);
}
